import { Nullable } from '@Src/commons/Ticketing/types';

export enum TicketingApiResponseStatus {
  idle,
  loading,
  succeeded,
  failed,
  noData,
  done,
  abort,
}

export interface TicketListItem {
  associated_tickets_count: any;
  association_type: any;
  cc_emails: any;
  company_id: any;
  created_at: any;
  custom_fields: any;
  description: any;
  description_text: any;
  due_by: any;
  email_config_id: any;
  form_id: any;
  fr_due_by: any;
  fr_escalated: any;
  fwd_emails: any;
  group_id: any;
  id: any;
  is_escalated: any;
  nr_due_by: any;
  nr_escalated: any;
  priority: any;
  product_id: any;
  reply_cc_emails: any;
  requester_id: any;
  responder_id: any;
  source: any;
  spam: any;
  status: any;
  subject: any;
  support_email: any;
  tags: any;
  ticket_cc_emails: any;
  to_emails: any;
  type: any;
  updated_at: any;
}

export interface Person {
  email: any;
  id: any;
  mobile: any;
  name: any;
  phone: any;
}

export interface Attachment {
  id: any;
  content_type: any;
  size: any;
  name: any;
  attachment_url: any;
  created_at: any;
  updated_at: any;
}

export interface Conversation {
  attachments: Attachment[];
  author: Nullable<Person>;
  auto_response: any;
  automation_id: any;
  automation_type_id: any;
  bcc_emails: any;
  body: any;
  body_text: any;
  category: any;
  cc_emails: any;
  created_at: any;
  email_failure_count: any;
  from_email: any;
  id: any;
  incoming: any;
  last_edited_at: any;
  last_edited_user_id: any;
  outgoing_failures: any;
  private: any;
  source: any;
  source_additional_info: any;
  support_email: any;
  thread_id: any;
  thread_message_id: any;
  ticket_id: any;
  to_emails: any;
  updated_at: any;
  user_id: any;
}

export interface TicketItem {
  association_type: any;
  attachments: Attachment[];
  cc_emails: any;
  company_id: any;
  conversations: Nullable<Conversation[]>;
  created_at: any;
  custom_fields: any;
  description: any;
  description_text: any;
  due_by: any;
  email_config_id: any;
  form_id: any;
  fr_due_by: any;
  fr_escalated: any;
  fwd_emails: any;
  group_id: any;
  id: any;
  is_escalated: any;
  nr_due_by: any;
  nr_escalated: any;
  priority: any;
  product_id: any;
  reply_cc_emails: any;
  requester: Nullable<Person>;
  requester_id: any;
  responder: any;
  responder_id: any;
  source: any;
  source_additional_info: any;
  spam: any;
  status: any;
  subject: any;
  support_email: any;
  tags: any;
  ticket_cc_emails: any;
  to_emails: any;
  type: any;
  updated_at: any;
}

export interface TicketListState {
  hasMore: boolean;
  status: TicketingApiResponseStatus;
  ticketList: TicketListItem[];
}

export const initialTicketListState: TicketListState = {
  hasMore: false,
  status: TicketingApiResponseStatus.idle,
  ticketList: [],
};

export interface TicketDetailsState {
  status: TicketingApiResponseStatus;
  ticketItem: Nullable<TicketItem>;
}

export const initialTicketDetailsState: TicketDetailsState = {
  status: TicketingApiResponseStatus.idle,
  ticketItem: null,
};

export interface CommentsState {
  status: TicketingApiResponseStatus;
  comments: Nullable<Conversation[]>;
}

export const initialCommentsState: CommentsState = {
  status: TicketingApiResponseStatus.idle,
  comments: [],
};

export const initialModalTicketListState: TicketListState = {
  status: TicketingApiResponseStatus.idle,
  ticketList: [],
  hasMore: false,
};
